/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

import { getCommandIntelligenceTokens, getGradientCtaSx } from '../../../theme/commandIntelligenceTokens';

export const getCommandIntelligenceAttachModalStyles = theme => {
  const tokens = getCommandIntelligenceTokens(theme);

  return {
    paper: {
      borderRadius: tokens.radiusCard,
      overflow: 'hidden',
      fontFamily: tokens.fontStack,
    },
    titleRoot: {
      display: 'flex',
      alignItems: 'flex-start',
      gap: 1,
      px: 2.5,
      py: 1.75,
      borderBottom: `1px solid ${tokens.borderSubtle}`,
    },
    titleStack: {
      flexGrow: 1,
      minWidth: 0,
    },
    titleIcon: {
      color: tokens.accentPrimary,
      fontSize: '1.25rem',
      mt: 0.25,
    },
    titleText: {
      fontWeight: 600,
      lineHeight: 1.2,
      color: tokens.textPrimary,
      fontFamily: tokens.fontStack,
    },
    titleSubtitle: {
      display: 'block',
      mt: 0.25,
      color: tokens.textMuted,
      fontFamily: tokens.fontStack,
    },
    closeButton: {
      ml: 1,
      color: tokens.textMuted,
    },
    content: {
      px: 2.5,
      py: 2,
    },
    searchField: {
      mb: 1.25,
      '& .MuiOutlinedInput-root': {
        borderRadius: tokens.radiusChip,
        bgcolor: tokens.surfaceInput,
        fontFamily: tokens.fontStack,
      },
    },
    poolCaption: {
      display: 'block',
      mb: 1,
      color: tokens.textMuted,
      fontFamily: tokens.fontStack,
    },
    list: {
      maxHeight: 360,
      overflow: 'auto',
      border: `1px solid ${tokens.borderSubtle}`,
      borderRadius: tokens.radiusChip,
      p: 0,
    },
    listItem: {
      py: 0.75,
      borderBottom: `1px solid ${tokens.borderSubtle}`,
      '&:last-of-type': {
        borderBottom: 0,
      },
      '&:hover': {
        bgcolor: 'action.hover',
      },
      '&.Mui-selected': {
        bgcolor: 'action.selected',
      },
      '&.Mui-disabled': {
        opacity: 0.72,
      },
    },
    attachedBadge: {
      ml: 1,
      color: tokens.textMuted,
      flexShrink: 0,
      fontFamily: tokens.fontStack,
    },
    actions: {
      px: 2.5,
      py: 1.5,
      borderTop: `1px solid ${tokens.borderSubtle}`,
      gap: 1,
    },
    cancelButton: {
      textTransform: 'none',
      color: tokens.textSecondary,
    },
    confirmButton: {
      textTransform: 'none',
      minWidth: 100,
      borderRadius: tokens.radiusChip,
      ...getGradientCtaSx(theme),
    },
  };
};
